import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store/index";
Vue.use(VueRouter);

// configure router
const router = new VueRouter({
	mode: "history",
	routes, // short for routes: routes
	linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
	if (to.matched.some((record) => record.meta.requiresAuth)) {

		if (store.getters["auth/isAuthenticated"] && !!localStorage.getItem('access_token') ) {
			next();
			return;
		}
		next("/login");
	} else {
		if (to.fullPath == "/logout") {
			next("/login");
			return;
		}
		next();
	}
});

export default router;
